/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "37c5f958151b58d9c4d8da473fd8429b0c948495";
